import { render, staticRenderFns } from "./NavbarUpdatePassword.vue?vue&type=template&id=3b3ad77c"
import script from "./NavbarUpdatePassword.vue?vue&type=script&lang=js"
export * from "./NavbarUpdatePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports